<template>
  <DepartmentPage />
</template>

<script>
import DepartmentPage from '~contemporaryTheme/pages/departments/_id'

export default {
  components: { DepartmentPage },
}
</script>
